export enum MarketingJobStatus {
  FAILED = 'failed',
  IN_PROGRESS = 'in_progress',
  SUCCESS = 'success',
}
